import React from 'react';

const InformationCardContentRankingLabelValue = ({ description, getSiteRanking, t, id }) => {
  return (
    <div>
      <span className="paragraph">
        <span className="heading5"> {t(description)} </span>
      </span>
      <span className="paragraph">{getSiteRanking && getSiteRanking()}</span>
    </div>
  );
};

export default InformationCardContentRankingLabelValue; 